<template>
	<div class="common-header">
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane name="home">
				<span slot="label"><img class="logo" src="../../assets/images/logo.png" /><i class="newfan">新帆玩具</i><i
						class="at">@</i><i class="pinpai">品牌森林</i></span>
			</el-tab-pane>
			<el-tab-pane label="首页" name="home1"></el-tab-pane>
			<el-tab-pane label="所有宝贝" name="ad"></el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	export default {
		data() {
		  return {
			  activeName: 'home'
		  }
		},
		
		methods: {
		  handleClick(obj, evt) {
		    if(this.$route.path !='/home' && this.activeName == 'home'){
				this.$router.push({path:'/home'})
			}else if(this.$route.path !='/home1' && this.activeName == 'home1'){
				this.$router.push({path:'/home'})
			}else if( this.$route.path !='/ad' && this.activeName == 'ad'){
				this.$router.push({path:'/ad'})
			}else if( this.$route.path !='/litapp' && this.activeName == 'litapp'){
				this.$router.push({path:'/litapp'})
			}else if( this.$route.path !='/download' && this.activeName == 'download'){
				this.$router.push({path:'/download'})
			}else if( this.$route.path !='/success' && this.activeName == 'success'){
				this.$router.push({path:'/success'})
			}else if( this.$route.path !='/about' && this.activeName == 'about'){
				this.$router.push({path:'/about'})
			}
		  }
		}
	}
</script>

<style lang="scss">
	.common-header {
		width: 1400px;
		overflow: hidden;
		margin-left: auto;
		margin-right: auto;
		
		.el-tabs__header {
			margin: 0px !important;
		}
		
		.el-tabs__item {
			padding: 10px 150px 10px 50px;
			height: 60px;
			font-size: 16px;
			font-weight: 600;
		
			.logo {
				display: block;
				float: left;
				padding: 0 2px;
				width: 32px;
				height: 30px;
				margin-top: 2px;
			}
		
			.newfan {
				color: #007598;
				font-size: 20px;
			}
		
			.at {
				color: #888;
				font-size: 16px;
				padding: 2px 3px 5px 5px;
			}
		
			.pinpai {
				color: #0f97ff;
				font-size: 18px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/header/index.vue